import type { AppointmentsData, IMedcenter } from '@/entities/medcenter/model/types';

import type { DiscountInfo } from '../model/types';

export const getDiscountInfo = (appointmentType: 'online' | 'primary', appointment: AppointmentsData): DiscountInfo => {
  if (appointment?.priceWithDiscount) {
    return {
      type: appointmentType,
      discount: appointment.discountPercentage!,
    };
  }

  return null;
};

export const getDiscount = (medcenterWithDiscount: IMedcenter) => {
  const { online, primary } = medcenterWithDiscount.appointments;

  return getDiscountInfo('online', online) || getDiscountInfo('primary', primary) || null;
};
